import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
    const { pathname, hash, key } = useLocation();

    useEffect(() => {
        const scroller = document.querySelector('.scroller');

        const withSnapDisabled = (fn) => {
            if (!scroller) return fn();
            const prevSnap = scroller.style.scrollSnapType;
            const prevBehavior = scroller.style.scrollBehavior;
            scroller.style.scrollSnapType = 'none';
            scroller.style.scrollBehavior = 'auto';
            try {
                return fn();
            } finally {
                // Restore on next frame to avoid mid-scroll snap glitches.
                requestAnimationFrame(() => {
                    scroller.style.scrollSnapType = prevSnap;
                    scroller.style.scrollBehavior = prevBehavior;
                });
            }
        };

        // Empty hash: hard reset to the top immediately (no smooth, no snap interference).
        if (!hash) {
            withSnapDisabled(() => {
                if (scroller) scroller.scrollTop = 0;
                window.scrollTo(0, 0);
            });
            return;
        }

        const id = hash.replace('#', '');
        if (!id) return; // Ignore href="#" and similar.

        // For a snap-scrolling app, always scroll to the nearest .section wrapper,
        // otherwise scroll-snap can "correct" to the wrong target (often the footer).
        const attemptScroll = (retries = 6) => {
            const element = document.getElementById(id);
            if (element) {
                const target = element.closest('section.section') || element;
                // Hash scrolling + CSS scroll-snap can fight each other and "snap away" from the target.
                // Temporarily disable snap/behavior while we move to the target.
                withSnapDisabled(() => {
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
                return;
            }
            if (retries > 0) setTimeout(() => attemptScroll(retries - 1), 200);
        };

        // Delay a bit to allow route content to mount before we look for the id.
        setTimeout(() => attemptScroll(), 50);
    }, [pathname, hash, key]);

    return null;
};

export default ScrollToHash;
